<button
  mat-icon-button
  (click)="openUrl()"
  tabindex="-1"
  class="stroked medium primary mr-2 mt-0.5"
>
  <span class="material-symbols-outlined"> travel_explore </span>
</button>
